import React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import CheckIcon from '@mui/icons-material/Check'

export type ListSelectMenuOption = {
  id: string
  title: React.ReactNode
}

export type ListSelectMenuProps = {
  options: ListSelectMenuOption[]
  isOptionSelected: (option: ListSelectMenuOption) => boolean
  onSelectOption: (option: ListSelectMenuOption) => any
  renderOption?: (
    option: ListSelectMenuOption,
    selected: boolean
  ) => React.ReactNode
}

const ListSelectMenu: React.FC<ListSelectMenuProps> = ({
  options,
  isOptionSelected,
  onSelectOption,
  renderOption = (opt) => opt.title,
}) => {
  return (
    <List dense>
      {options.map((option) => {
        const selected = isOptionSelected(option)
        const handler = () => onSelectOption(option)
        return (
          <ListItem
            disablePadding
            key={option.id}
            selected={selected}
            secondaryAction={
              selected ? (
                <ListItemIcon>
                  <CheckIcon />
                </ListItemIcon>
              ) : undefined
            }
          >
            <ListItemButton onClick={handler}>
              <ListItemText primary={renderOption(option, selected)} />
            </ListItemButton>
          </ListItem>
        )
      })}
    </List>
  )
}

export default ListSelectMenu
